import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 59,
	height: 58,
	viewBox: "0 0 59 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M29.5 58C33.3083 58 37.0794 57.2499 40.5978 55.7925C44.1163 54.3351 47.3132 52.199 50.0061 49.5061C52.699 46.8132 54.8351 43.6163 56.2925 40.0978C57.7499 36.5794 58.5 32.8083 58.5 29C58.5 25.1917 57.7499 21.4206 56.2925 17.9022C54.8351 14.3837 52.699 11.1868 50.0061 8.4939C47.3132 5.801 44.1163 3.66488 40.5978 2.20749C37.0794 0.750107 33.3083 -5.67486e-08 29.5 0C21.8087 1.14609e-07 14.4325 3.05535 8.9939 8.4939C3.55535 13.9325 0.5 21.3087 0.5 29C0.5 36.6913 3.55535 44.0675 8.9939 49.5061C14.4325 54.9447 21.8087 58 29.5 58ZM28.7524 40.7289L44.8636 21.3956L39.9142 17.2711L26.0587 33.8946L18.8892 26.7219L14.333 31.2781L23.9997 40.9448L26.4937 43.4388L28.7524 40.7289Z",
		fill: "currentColor"
	})
});
export default SvgSuccess;
